import React from "react";
import Student from "./Student";

const Alumini = () => {
  return (
    <div>
      <Student
        title="All Alumni"
        fieldname="year"
        cata="Add Alumni"
        link="add-alumni"
        head="alumni"
      />
    </div>
  );
};

export default Alumini;
